var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.5,19.8C10.5,19.8,10.5,19.8,10.5,19.8c-0.3,0-0.4-0.2-0.5-0.4l-1.9-7.6L0.5,10C0.3,9.9,0.2,9.8,0.2,9.6 c0-0.2,0.1-0.4,0.3-0.5l18.7-8.8c0.2-0.1,0.4-0.1,0.6,0.1s0.2,0.4,0.1,0.6l-8.8,18.7C10.9,19.7,10.7,19.8,10.5,19.8z M2.1,9.4 L8.6,11C8.8,11,9,11.2,9,11.4l1.6,6.5l7.6-16.1L2.1,9.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/sendMessage.7b99af90004b460a4f0f5fa202cbf01c.svg";
export { ForwardRef as ReactComponent };